import { render, staticRenderFns } from "./locationWrapper.vue?vue&type=template&id=77aba77b&scoped=true"
import script from "./locationWrapper.vue?vue&type=script&lang=js"
export * from "./locationWrapper.vue?vue&type=script&lang=js"
import style0 from "./locationWrapper.vue?vue&type=style&index=0&id=77aba77b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aba77b",
  null
  
)

export default component.exports